import type { Movie } from '@/types';

export const movies: Movie[] = [
  {
    id: 'yu-nv-xin-jing-2',
    title: '玉女心经2',
    subtitle: '心经重出，江湖再起波澜',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20wuxia%20film%20poster%20illustration%2C%20elegant%20female%20swordswoman%20in%20flowing%20jade%20green%20and%20cream%20robes%20standing%20in%20a%20misty%20bamboo%20forest%2C%20warm%20orange%20rim%20light%2C%20muted%20dark%20green%20and%20beige%20palette%2C%20refined%20editorial%20art%2C%20soft%20film%20grain%2C%20large%20negative%20space%20at%20top%20for%20title%20text&width=600&height=900&seq=yunu2-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Sweeping%20cinematic%20wide%20shot%20of%20a%20misty%20mountain%20valley%20at%20dawn%20with%20ancient%20Chinese%20pavilions%20and%20a%20lone%20figure%20in%20jade%20green%20robes%2C%20muted%20dark%20green%20and%20warm%20beige%20tones%2C%20soft%20orange%20sun%20haze%2C%20painterly%20period%20film%20still%2C%20atmospheric%20and%20serene&width=1600&height=900&seq=yunu2-backdrop&orientation=landscape',
    year: 2025,
    region: '中国香港',
    genres: ['武侠', '剧情', '爱情'],
    duration: '128分钟',
    director: '程慕白',
    cast: ['林清鸢', '张启伦', '陆无咎', '苏晓棠'],
    rating: 8.7,
    views: 1284563,
    updatedAt: '2025-09-28',
    category: '武侠',
    featured: true,
    synopsis:
      '十年之后，传说中能逆转经脉、照见本心的《玉女心经》再度现身江湖。昔日闭关的玉女为寻回失散的师门信物重入尘世，却卷入一场由旧日仇怨编织的暗局。她与冷面侠客沈司白从猜忌走向并肩，在玄阴一脉步步紧逼的杀局中，逐步揭开当年覆灭的真正缘由。心经之秘、师门之痛、情义之择交织一处，她终于明白，真正的修行从来不是无欲无求，而是在看清人心之后仍愿执剑向光。',
  },
  {
    id: 'yu-nv-xin-jing',
    title: '玉女心经',
    subtitle: '前尘旧事，心经初现',
    poster: 'https://readdy.ai/api/search-image?query=Classic%20wuxia%20film%20poster%20illustration%20of%20a%20young%20female%20martial%20artist%20in%20simple%20white%20robes%20holding%20a%20slim%20jade%20sword%2C%20ancient%20stone%20bridge%20and%20plum%20blossoms%20behind%2C%20soft%20beige%20and%20dark%20green%20palette%2C%20delicate%20orange%20accents%2C%20refined%20editorial%20art%2C%20gentle%20grain%20texture%2C%20calm%20negative%20space&width=600&height=900&seq=yunu1-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Atmospheric%20period%20film%20wide%20shot%20of%20a%20quiet%20ancient%20courtyard%20with%20blooming%20plum%20trees%20and%20a%20solitary%20figure%20practicing%20sword%20forms%20at%20dusk%2C%20muted%20dark%20green%20and%20warm%20beige%20tone%2C%20soft%20orange%20lantern%20glow%2C%20painterly%20and%20serene&width=1600&height=900&seq=yunu1-backdrop&orientation=landscape',
    year: 2023,
    region: '中国香港',
    genres: ['武侠', '爱情'],
    duration: '116分钟',
    director: '程慕白',
    cast: ['林清鸢', '沈砚'],
    rating: 8.1,
    views: 968210,
    updatedAt: '2025-08-14',
    category: '武侠',
    synopsis:
      '少年玉女在师门覆灭之夜习得失传的《玉女心经》，为护住最后一线传承隐姓埋名。她与书生沈砚在乱世中相遇，一段以身相护的情谊在刀光剑影中缓缓生根。当旧敌寻踪而至，她必须第一次以自己的方式做出选择。',
  },
  {
    id: 'jian-ying-jiang-hu',
    title: '剑影江湖',
    subtitle: '一剑破局，恩怨两清',
    poster: 'https://readdy.ai/api/search-image?query=Dramatic%20wuxia%20film%20poster%20of%20a%20lone%20swordsman%20in%20dark%20green%20robes%20standing%20on%20a%20cliff%20edge%20against%20a%20stormy%20sky%2C%20cold%20steel%20sword%20glinting%2C%20muted%20forest%20green%20and%20cream%20palette%2C%20fierce%20orange%20lightning%20accent%2C%20refined%20painterly%20editorial%20style%2C%20gritty%20film%20texture%2C%20bold%20negative%20space&width=600&height=900&seq=jianying-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20martial%20arts%20film%20wide%20scene%20of%20two%20swordsmen%20facing%20off%20on%20a%20rain%20slicked%20stone%20plaza%20of%20an%20ancient%20town%2C%20muted%20dark%20green%20and%20beige%20tone%2C%20warm%20orange%20lantern%20light%20reflections%2C%20painterly%20cinematic%20still%2C%20tense%20atmosphere&width=1600&height=900&seq=jianying-backdrop&orientation=landscape',
    year: 2025,
    region: '中国大陆',
    genres: ['武侠', '动作'],
    duration: '121分钟',
    director: '韩九思',
    cast: ['江彻', '柳如烟'],
    rating: 7.9,
    views: 742310,
    updatedAt: '2025-10-02',
    category: '武侠',
    synopsis:
      '退隐十年的剑客江彻因一纸旧约重返江湖，昔日结拜兄弟却已成一方势力之主。一桩灭门旧案的真相藏在层层谎言之下，剑出鞘的那一刻，他要在情义与公道之间做出最后的抉择。',
  },
  {
    id: 'hua-jian-ling',
    title: '花间令',
    subtitle: '一令既出，疑云四起',
    poster: 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20mystery%20drama%20poster%20of%20a%20female%20investigator%20in%20deep%20green%20hanfu%20holding%20a%20sealed%20letter%20beside%20lanterns%20and%20falling%20petals%2C%20muted%20dark%20green%20and%20cream%20palette%2C%20warm%20orange%20glow%2C%20refined%20editorial%20illustration%2C%20delicate%20grain%2C%20layered%20composition&width=600&height=900&seq=huajianling-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Atmospheric%20ancient%20Chinese%20mansion%20courtyard%20at%20night%20lit%20by%20warm%20lanterns%20with%20a%20figure%20examining%20clues%20among%20fallen%20petals%2C%20muted%20dark%20green%20and%20beige%20tones%2C%20soft%20orange%20light%2C%20painterly%20period%20mystery%20film%20still&width=1600&height=900&seq=huajianling-backdrop&orientation=landscape',
    year: 2024,
    region: '中国大陆',
    genres: ['古装', '悬疑', '剧情'],
    duration: '112分钟',
    director: '周允行',
    cast: ['花间', '顾九思'],
    rating: 8.3,
    views: 813654,
    updatedAt: '2025-07-21',
    category: '悬疑',
    synopsis:
      '一封没有落款的「花间令」在城中流传，凡持令者皆卷入离奇旧事。女捕快花间循线追查，发现每桩案件都指向十年前的同一场大火。真相越是逼近，她越发现，最亲近的人或许正是最关键的那一环。',
  },
  {
    id: 'nan-hai-gui-xu',
    title: '南海归墟',
    subtitle: '深海之下，藏着传说',
    poster: 'https://readdy.ai/api/search-image?query=Adventure%20fantasy%20film%20poster%20of%20an%20ancient%20sunken%20temple%20beneath%20deep%20turquoise%20water%20with%20a%20diver%20silhouette%20and%20mysterious%20carved%20gates%2C%20muted%20deep%20green%20and%20cream%20palette%2C%20warm%20orange%20artifact%20glow%2C%20refined%20editorial%20illustration%2C%20cinematic%20depth%2C%20soft%20grain&width=600&height=900&seq=nanhai-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Grand%20underwater%20ruins%20scene%20with%20towering%20ancient%20carved%20stone%20gates%20and%20rays%20of%20light%20piercing%20deep%20green%20water%2C%20distant%20small%20explorer%20figure%2C%20muted%20dark%20green%20and%20beige%20palette%2C%20warm%20orange%20glow%20among%20ruins%2C%20painterly%20cinematic%20still&width=1600&height=900&seq=nanhai-backdrop&orientation=landscape',
    year: 2024,
    region: '中国大陆',
    genres: ['冒险', '奇幻'],
    duration: '134分钟',
    director: '沈砚舟',
    cast: ['陈暮', '阿蛮'],
    rating: 7.6,
    views: 689432,
    updatedAt: '2025-06-30',
    category: '奇幻',
    synopsis:
      '一支民间考古队根据残卷线索潜入南海深处，寻找传说中沉没的归墟古城。随着下潜深入，队员们发现古城的机关与自身的家族往事紧密相连，而这片海域真正守护的秘密，远不止一座城池。',
  },
  {
    id: 'chang-an-ye-xing',
    title: '长安夜行',
    subtitle: '夜灯如昼，暗流涌动',
    poster: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20capital%20city%20night%20drama%20poster%20of%20a%20cloaked%20figure%20walking%20a%20lantern%20lit%20stone%20street%20under%20falling%20snow%2C%20tall%20wooden%20towers%20behind%2C%20muted%20dark%20green%20and%20cream%20palette%2C%20warm%20orange%20lantern%20glow%2C%20refined%20editorial%20illustration%2C%20delicate%20grain&width=600&height=900&seq=changan-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Breathtaking%20panorama%20of%20an%20ancient%20Chinese%20capital%20at%20night%2C%20countless%20warm%20lanterns%20along%20snowy%20streets%20and%20tall%20wooden%20towers%2C%20muted%20dark%20green%20and%20beige%20tones%2C%20soft%20orange%20light%2C%20painterly%20period%20cinematic%20still%2C%20serene%20and%20mysterious&width=1600&height=900&seq=changan-backdrop&orientation=landscape',
    year: 2022,
    region: '中国大陆',
    genres: ['古装', '悬疑', '动作'],
    duration: '119分钟',
    director: '裴之衡',
    cast: ['裴行', '苏莞'],
    rating: 8.0,
    views: 601233,
    updatedAt: '2025-05-18',
    category: '悬疑',
    synopsis:
      '长安城入夜后宵禁森严，一桩桩不流血的盗窃案却接连发生。巡夜校尉裴行与文书苏莞被迫联手，在灯火与暗巷之间追查一枚消失的印记。越接近真相，他们越发现，这座城最深的夜，不在巷子里，而在人心。',
  },
];